import * as z from "zod/v4";

export const newsletterSignupFormSchema = z.object({
	email: z.email("Valid email is required"),
	firstName: z.string().trim().max(60).optional(),
	lastName: z.string().trim().max(60).optional(),
	constantContactListId: z.string().min(1, "Constant Contact list ID is required")
});

export type NewsletterSignupFormSchema = z.infer<typeof newsletterSignupFormSchema>;

export const newsletterSignupFormClientSchema = newsletterSignupFormSchema.pick({
	email: true,
	firstName: true,
	lastName: true
});

export const exitIntentNewsletterFormSchema = z.object({
	email: z.email("Valid email is required"),
	firstName: z.string().trim().min(1, "First name is required").max(60),
	lastName: z.string().trim().min(1, "Last name is required").max(60)
});

export type ExitIntentNewsletterFormSchema = z.infer<typeof exitIntentNewsletterFormSchema>;
